import { useEffect, useState, useContext, useRef } from "react";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { Image } from "../../components/filePreview.js";

function General() {
  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);

  const [settings, setSetting] = useState(null);

  const fileUploadRef = useRef(null);

  const [logoID, setLogoID] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [tin, setTIN] = useState('');
  const [gpn, setGPN] = useState('');

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.get('/api/admin/settings', {
        
      }),
    ]).then(axios.spread((settings) => {
      setSetting(settings.data);
      setLogoID(settings.data.logoID);
      setTitle(settings.data.title || '');
      setDescription(settings.data.description || '');
      setTIN(settings.data.tin || '');
      setGPN(settings.data.gpn || '');
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  // Logo
  function triggerFileInput() {
    fileUploadRef.current.click();
  }

  function changeFileInput(e) {
    var data = new FormData();

    data.append('logo', e.target.files[0]);
    
    let u = context.addSpiner();
    axios.post('/api/admin/settings/updateLogo', data).then((response) => {
      setLogoID(response.data.logoID);
      setSetting(settings => {
        return {
          ...settings,
          logoID: response.data.logoID
        };
      });
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
      // Reset the file input so subsequent uploads trigger onChange
      e.target.value = '';
    });
  }

  function updateField(field, value) {
    let u = context.addSpiner();
    // title is a non-pointer string on the backend; always send the value.
    // Other fields use null to clear.
    const stored = field === 'title' ? value : (value !== "" ? value : null);
    axios.post('/api/admin/settings/update', { [field]: stored }).then(() => {
      setSetting(settings => ({
        ...settings,
        [field]: stored
      }));
    }).catch((e) => {
      context.addError(e);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | General Settings" />

      <input ref={fileUploadRef} type="file" className="d-none" onChange={changeFileInput} accept=".jpg,.jpeg,.png,.tiff" multiple={false} />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Organization Settings</div>
                <div className="typo-normal-175">Manage organization-wide settings and preferences</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">

            <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">General Information</div>
              </div>
              <div className="card-content sm">
                <div className="row">
                  <div className="col-xs-3">
                    <div className="typo-strong-125 mb-1">Logo</div>
                    <Image id={logoID} onClick={triggerFileInput} style={{maxHeight: '100px', maxWidth: '100%'}} alt="Click to upload logo" />
                    <div className="typo-normal-125 text-muted mt-1">Click to upload a new image.</div>
                  </div>
                  <div className="col-xs-9">
                    <div className="typo-strong-125">Name</div>
                    <input type="text" placeholder="Name..." value={title} onChange={(e) => setTitle(e.target.value)} onBlur={() => updateField('title', title)} className="input sm typo-normal-150 w-25" />
                    <div className="typo-normal-125 text-muted mt-1">Official name of your organization. Also used as the billing provider name on claims.</div>

                    <br />
                  
                    <div className="typo-strong-125">Description</div>
                    <input type="text" placeholder="Description..." value={description} onChange={(e) => setDescription(e.target.value)} onBlur={() => updateField('description', description)} className="input sm typo-normal-150 w-50" />
                    <div className="typo-normal-125 text-muted mt-1">Optional description of your organization. This will be used as a slogan in the application and documents.</div>

                    <br />

                    <div className="typo-strong-125">TIN</div>
                    <input type="text" placeholder="TIN..." value={tin} onChange={(e) => setTIN(e.target.value)} onBlur={() => updateField('tin', tin)} className="input sm typo-normal-150 w-25" />
                    <div className="typo-normal-125 text-muted mt-1">Tax Identification Number (TIN) is used by the IRS to identify taxpayers. It is required for tax reporting purposes.</div>

                    <br />

                    <div className="typo-strong-125">GUIDE Participant Number</div>
                    <input type="text" placeholder="GPN..." value={gpn} onChange={(e) => setGPN(e.target.value)} onBlur={() => updateField('gpn', gpn)} className="input sm typo-normal-150 w-25" />
                    <div className="typo-normal-125 text-muted mt-1">GUIDE Participant Number (GPN) is a unique identifier for participants in the GUIDE program. It is used to identify your organization in the healthcare system.</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default General;
